export const PasscodePageTemplateStyles = {
    overlay: "fixed inset-0 backdrop-blur-sm bg-black bg-opacity-40 flex flex-col items-center justify-center z-50 h-screen",
    container: "rounded-2xl bg-white flex flex-col items-center justify-start relative w-[90%] sm:w-[85%] md:w-[90%] h-fit max-h-[99vh] sm:max-h-[98vh] overflow-y-hidden shadow-iw-pin-page-container",
    contentWrapper: "flex flex-col items-center justify-start w-full mt-44 sm:mt-48 relative z-10 pb-0 sm:pb-8",
    titleContainer: "text-center space-y-5 relative w-full max-w-lg px-4 sm:px-0",
    title: "text-2xl-plus font-semibold text-iw-darkGrayishBlue",
    description: "text-iw-textTertiary text-lg font-normal mx-8",
    subTitle: {
        container: 'flex items-start gap-3 justify-center mx-4 px-2',
        backArrowButton: 'cursor-pointer mt-2 sm:mt-1',
        content: 'text-iw-textTertiary text-base font-medium',
    },
    errorAndContentContainer: "flex flex-col bg-white sm:rounded-lg sm:shadow-iw-pin-page-container items-center z-20 w-full max-w-lg mt-8 mb-4 mx-auto border-t border-iw-grayishBlue mx-8",
    warningTextBorder: "relative sm:hidden pin-page-warning-text-border min-w-full items-center justify-center mt-1 sm:mt-3 md:mt-5",
    warningTextContainer: "w-full items-center justify-center flex",
    warningText: "text-iw-textTertiary text-center text-sm sm:text-base px-4 sm:px-8 pt-4 sm:pt-6 max-w-xl",
    errorContainer: "bg-iw-pink50 w-full px-3 sm:px-5 py-3 border-t sm:rounded-t-lg",
    errorContentWrapper: "flex items-start justify-between gap-2 max-w-xl mx-auto",
    errorText: "text-sm text-iw-darkRed break-words whitespace-normal",
    errorTextContainer: "flex-1 pr-2",
    closeButtonContainer: "flex-shrink-0",
    closeButton: "cursor-pointer",
    closeIcon: "min-w-[26px] min-h-[26px] mt-1.5 sm:mt-2 text-iw-darkRed",
    bottomBorder: "pin-page-warning-text-border w-full mt-2 sm:mt-3 md:mt-5",
    contentContainer: "w-full px-4 sm:px-8 py-3 sm:py-5 md:py-7 space-y-4 flex flex-col items-center",
}